import { render, staticRenderFns } from "./MapIconKindergartenSmile.vue?vue&type=template&id=01bcd2a6&scoped=true&"
import script from "./MapIconKindergartenSmile.vue?vue&type=script&lang=js&"
export * from "./MapIconKindergartenSmile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bcd2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bcd2a6')) {
      api.createRecord('01bcd2a6', component.options)
    } else {
      api.reload('01bcd2a6', component.options)
    }
    module.hot.accept("./MapIconKindergartenSmile.vue?vue&type=template&id=01bcd2a6&scoped=true&", function () {
      api.rerender('01bcd2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconKindergartenSmile.vue"
export default component.exports